<span class="fa-stack" [ngClass]="size">
    <i class="fas fa-circle fa-stack-2x" aria-hidden="true"></i>
    <i class="fa-stack-1x" [ngClass]="faIcon" aria-hidden="true"></i>
</span>
